import axios from "axios";
import swal from "sweetalert";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import {
	loginConfirmedAction,
	Logout,
	setLang,
} from "../store/actions/AuthActions";

const tokenKey = "yusurToken";

export function login(email, password, type) {
	const postData = { email, password };
	if (type === "admin") {
		return axios.post(`${API_BASE_URL_ENV()}/admin/login`, postData);
	}
	return axios.post(`${API_BASE_URL_ENV()}/vender/login`, postData);
}

export function formatError(errorResponse) {
	switch (errorResponse?.message) {
		case "EMAIL_EXISTS":
			//return 'Email already exists';
			swal("Oops", "Email already exists", "error");
			break;
		case "User not Exist.":
			swal("Oops", "Email not found", "error", { button: "Try Again!" });
			break;
		case "Incorrect Password.":
			//return 'Invalid Password';
			swal("Oops", "Incorrect Password", "error", { button: "Try Again!" });
			break;
		case "كلمة سر خاطئة":
			//return 'Invalid Password';
			swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
			break;
		case "USER_DISABLED":
			return "User Disabled";
		default:
			return "";
	}
}

export function getJwt() {
	return localStorage.getItem(tokenKey);
}

export function saveTokenInLocalStorage(tokenDetails) {
	localStorage.setItem("yusurAdmin", JSON.stringify(tokenDetails));
	localStorage.setItem(tokenKey, tokenDetails.accessToken);
}

export function checkAutoLogin(dispatch, navigate) {
	const tokenDetailsString = localStorage.getItem("yusurAdmin") || "";
	const adminLang = localStorage.getItem("yusurLang");
	let tokenDetails = "";
	if (!tokenDetailsString || window?.location?.pathname?.includes("/login")) {
		dispatch(Logout(navigate));
		return;
	}
	tokenDetails = JSON.parse(tokenDetailsString);

	dispatch(loginConfirmedAction(tokenDetails));

	if (adminLang === "en") {
		dispatch(setLang("en"));
	} else {
		dispatch(setLang("ar"));
	}
}
